
    const mainSwiper = new Swiper('.product-main-homepage-slider', {
        loop: true,
        slidesPerView: 1,
        effect: "fade",
        fadeEffect: { crossFade: true },
        //speed: 100,
        navigation: {
            nextEl: ".button-next-homepage-slider",
            prevEl: ".button-prev-homepage-slider"
        }
    });

    const thumbSwiper = new Swiper('.product-shape-homepage-slider', {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 5,
        grabCursor: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        observer: true,
        observeParents: true,
        breakpoints: {
        768: {
            loop: false,
            slidesPerView: 5,
            spaceBetween: 23,
        },
        992: {
            loop: false,
            slidesPerView: 8,
            spaceBetween: 23,
        },
        1200: {
            slidesPerView: 10,
            spaceBetween: 23,
            allowTouchMove: false, // Disable swiping
            loop: false,           // Disable looping
        }
        }
    });

    // Link controllers
    thumbSwiper.controller.control = mainSwiper;
    mainSwiper.controller.control = thumbSwiper;

    // Hover-to-change only on large screens (1200px and up)
    if (window.innerWidth >= 1200) {
        document.querySelectorAll('.product-shape-homepage-slider .swiper-slide').forEach((slide, index) => {
            slide.addEventListener('mouseenter', () => {
                mainSwiper.slideToLoop(index);
            });
        });
    }
